import { Component, Inject, OnInit } from '@angular/core';
import * as XLSX from 'xlsx';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-representativewise-sadhyasthiti-report',
  // standalone: true,
  // imports: [],
  templateUrl: './representativewise-sadhyasthiti-report.component.html',
  styleUrl: './representativewise-sadhyasthiti-report.component.scss'
})
export class RepresentativewiseSadhyasthitiReportComponent implements OnInit {

  isLoading: boolean = false;
  startDate = '';
  endDate = '';
representativeData: any[] = [];

totalPostTotal = 0;
totalHasteTotal = 0;
totalMagzineTotal = 0;
totalDigitalTotal = 0;
grandTotal = 0;


  constructor(
    private dialogRef: MatDialogRef<RepresentativewiseSadhyasthitiReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    this.isLoading = true;

  const rawData = this.data['data'] || [];

   this.endDate = this.data['issuedate'];
    let weekfirstday =
      new Date(this.data['issuedate']).getDate() -
      new Date(this.data['issuedate']).getDay();
    this.startDate = formatDate(
      new Date(this.data['issuedate']).setDate(weekfirstday - 7),
      'yyyy-MM-dd',
      'en-IN',
      'GMT+0530'
    );

  this.setRepresentativeData(rawData);

  this.isLoading = false;

  }


setRepresentativeData(data: any[]) {

  this.totalPostTotal = 0;
  this.totalHasteTotal = 0;
  this.totalMagzineTotal = 0;
  this.totalDigitalTotal = 0;
  this.grandTotal = 0;

  const repMap = new Map<string, any>();

  data.forEach(item => {

    const repName = item?.rep_name || 'Unknown';

    // if (!repMap.has(repName)) {
    //   repMap.set(repName, {
    //     repName,
    //     post: 0,
    //     haste: 0,
    //     magazine: 0,
    //     digital: 0,
    //     total: 0
    //   });
    // }

    if (!repMap.has(repName)) {
  repMap.set(repName, {
    repName,
    dis_tal: item?.dis_tal || item?.district_taluka || item?.taluka || '',
    rep_taluka : item?.rep_taluka || '',
    post: 0,
    haste: 0,
    magazine: 0,
    digital: 0,
    total: 0
  });
}


    const rep = repMap.get(repName);

    const mode = item?.delivery_mode?.trim();

    if (mode === 'टपाल') {
      rep.post++;
      this.totalPostTotal++;
    }
    else if (mode === 'हस्ते') {
      rep.haste++;
      this.totalHasteTotal++;
    }
    else if (mode === 'मॅगझीन पोस्ट') {
      rep.magazine++;
      this.totalMagzineTotal++;
    }
    else if (mode === 'डिजिटल') {
      rep.digital++;
      this.totalDigitalTotal++;
    }

  });

  this.representativeData = Array.from(repMap.values());

  this.representativeData.forEach(rep => {
    rep.total = rep.post + rep.haste + rep.magazine + rep.digital;
    this.grandTotal += rep.total;
  });

}


  // uniqueData(data, key) {
  //   return [...new Map(data.map((a) => [key(a), a])).values()];
  // }


  exportExcel(fileName) {
    /* table id is passed over here */
    let element = document.getElementById('print-section');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, fileName + '.xlsx');
  }

//Correct Method
// printPage() {

//   const element = document.getElementById('print-section');

//   if (!element) {
//     console.error("Print section not found!");
//     return;
//   }

//   const printWindow = window.open('', '_blank');

//   if (!printWindow) {
//     console.error("Failed to open print window.");
//     return;
//   }

//   printWindow.document.write(`
//   <html>
//   <head>
//     <title>Ultra Print</title>

//     <style>

//     @page{
//         size:A4 portrait;
//         margin:8mm;
//     }

//     body{
//         margin:0;
//         font-family: Arial, Helvetica, sans-serif;
//     }

//     /* 🔥 CORE TABLE — AUTO COLUMN WIDTH */
//    table{
//     width:max-content;   /* ⭐ MAGIC */
//     min-width:100%;
//     border-collapse:collapse;
//     border:2px solid #000;
//     table-layout:auto;
// }


//     th, td{
//         border:1px solid #000;
//         padding:6px 8px;
//         white-space:nowrap;     /* ⭐ NEVER BREAK ROW */
//     }

//     thead th{
//         font-size:14px;
//         font-weight:700;
//         text-align:center;
//         background:#f5f5f5;
//     }

//     tbody td{
//         font-size:13px;
//     }

//     /* ✅ SERIAL — VERY SMALL */
//     table th:nth-child(1),
//     table td:nth-child(1){
//         width:1%;
//         white-space:nowrap;
//         text-align:center;
//     }

//     /* ✅ ⭐⭐⭐ ULTRA FLEXIBLE 2ND COLUMN ⭐⭐⭐ */
//   /* ✅ PERFECT FLEXIBLE 2ND COLUMN */
// table th:nth-child(2),
// table td:nth-child(2){

//     width:auto;          /* ⭐ KEY FIX */
//     min-width:50px;     /* prevents collapsing */

//     white-space:nowrap;  
//     word-break:keep-all; 
//     overflow:hidden;
//     text-overflow:ellipsis;

//     text-align:left;
// }


//     /* ✅ POST */
//     table th:nth-child(3),
//     table td:nth-child(3){
//         width:1%;
//         white-space:nowrap;
//         text-align:center;
//     }

//     /* ✅ OTHER NUMERIC */
//     table th:nth-child(n+4),
//     table td:nth-child(n+4){
//         width:1%;
//         white-space:nowrap;
//         text-align:center;
//     }

//     table tbody tr:last-child{
//         font-weight:700;
//         background:#efefef;
//     }

//     /* 🔥 PRINT FIX */
//     @media print{

//         body{
//             margin:0;
//         }

//         #print-section{
//             overflow:visible;
//         }

//         thead{
//             display:table-header-group;
//         }

//         tr{
//             page-break-inside:avoid;
//         }

//         .noPrint{
//             display:none !important;
//         }
//     }

//     </style>
//   </head>

//   <body>
//     ${element.outerHTML}

//     <script>
//       window.onload = function(){
//         setTimeout(function(){
//           window.focus();
//           window.print();
//           window.close();
//         }, 300);
//       }
//     <\/script>

//   </body>
//   </html>
//   `);

//   printWindow.document.close();
// }


printPage() {

  const element = document.getElementById('print-section');

  if (!element) {
    console.error("Print section not found!");
    return;
  }

  const printWindow = window.open('', '_blank');

  if (!printWindow) {
    console.error("Failed to open print window.");
    return;
  }

  printWindow.document.write(`
  <html>
  <head>
    <title>Ultra Print</title>

    <style>

    @page{
        size:A4 portrait;
        margin:8mm;
    }

    body{
        margin:0;
        font-family: Arial, Helvetica, sans-serif;
    }

    /* 🔥 CORE TABLE — AUTO COLUMN WIDTH */
   table{
    width:max-content;   /* ⭐ MAGIC */
    min-width:100%;
    border-collapse:collapse;
    border:2px solid #000;
    table-layout:auto;
}


    th, td{
        border:1px solid #000;
        padding:6px 8px;
        white-space:nowrap;     /* ⭐ NEVER BREAK ROW */
    }

    thead th{
        font-size:14px;
        font-weight:700;
        text-align:center;
        background:#f5f5f5;
    }

    tbody td{
        font-size:13px;
    }

    /* ✅ SERIAL — VERY SMALL */
    table th:nth-child(1),
    table td:nth-child(1){
        width:1%;
        white-space:nowrap;
        text-align:center;
    }

    /* ✅ ⭐⭐⭐ ULTRA FLEXIBLE 2ND COLUMN ⭐⭐⭐ */
  /* ✅ PERFECT FLEXIBLE 2ND COLUMN */


table th:nth-child(2){

    width:auto;          /* ⭐ KEY FIX */
    min-width:50px;     /* prevents collapsing */

    white-space:nowrap;  
    word-break:keep-all; 
    overflow:hidden;
    text-overflow:ellipsis;

    text-align:centre;
}


table td:nth-child(2){

    width:auto;          /* ⭐ KEY FIX */
    min-width:50px;     /* prevents collapsing */

    white-space:nowrap;  
    word-break:keep-all; 
    overflow:hidden;
    text-overflow:ellipsis;

    text-align:left;
}


    /* ✅ POST */
    table th:nth-child(3),
    table td:nth-child(3){
        width:1%;
        white-space:nowrap;
        text-align:center;
    }

    /* ✅ OTHER NUMERIC */
    table th:nth-child(n+4),
    table td:nth-child(n+4){
        width:1%;
        white-space:nowrap;
        text-align:center;
    }

    table tbody tr:last-child{
        font-weight:700;
        background:#efefef;
    }

    /* 🔥 PRINT FIX */
    @media print{

        body{
            margin:0;
            display: flex;
            justify-content: center;
        }

        #print-section{
            overflow:visible;
        }

        table {
            margin: 0 auto;
        }

        thead{
            display:table-header-group;
        }

        tr{
            page-break-inside:avoid;
        }

        .noPrint{
            display:none !important;
        }
    }

    </style>
  </head>

  <body>
    ${element.outerHTML}

    <script>
      window.onload = function(){
        setTimeout(function(){
          window.focus();
          window.print();
          window.close();
        }, 300);
      }
    <\/script>

  </body>
  </html>
  `);

  printWindow.document.close();
}




}
